export default "__VITE_ASSET__402d09c1__"